import type { ConsentPurpose } from '@alamo/types';

export const CONSENT_PURPOSES: ConsentPurpose[] = [
  'data_processing',
  'marketing',
  'analytics',
  'communications',
  'comm-email',
  'comm-whatsapp',
  'comm-sms',
  'ranking_public_exposure',
];

export type ConsentGroupKey = 'essential' | 'communications' | 'preferences' | 'ranking';

export interface ConsentGroup {
  key: ConsentGroupKey;
  purposes: ConsentPurpose[];
}

export const CONSENT_GROUPS: ConsentGroup[] = [
  { key: 'essential', purposes: ['data_processing'] },
  {
    key: 'communications',
    purposes: ['communications', 'comm-email', 'comm-whatsapp', 'comm-sms'],
  },
  { key: 'preferences', purposes: ['marketing', 'analytics'] },
  { key: 'ranking', purposes: ['ranking_public_exposure'] },
];

export const REQUIRED_CONSENT_PURPOSES: ConsentPurpose[] = ['data_processing'];

export const CONSENT_TERM_VERSION = '1.0';

export function isRequiredConsentPurpose(purpose: ConsentPurpose): boolean {
  return REQUIRED_CONSENT_PURPOSES.includes(purpose);
}
